/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'animate.css/animate.min.css';
import React from 'react';
import { Button } from 'react-bootstrap';


const defaultProps = {
  status: 'ready',
  icon: null,
  label: null,
  successLabel: null,
  failedLabel: null,
  loadingLabel: null,
  disabled: false,
  className: null,
  type: null,
  onClick: () => {},
  onStatusReset: () => {},
};

const propTypes = {
  status: React.PropTypes.string,
  icon: React.PropTypes.node,
  label: React.PropTypes.node,
  successLabel: React.PropTypes.node,
  failedLabel: React.PropTypes.node,
  loadingLabel: React.PropTypes.node,
  disabled: React.PropTypes.bool,
  className: React.PropTypes.string,
  type: React.PropTypes.string,
  onClick: React.PropTypes.func,
  onStatusReset: React.PropTypes.func,
};

class ActionButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status !== this.props.status) {
      this.setState({
        status: nextProps.status,
      });

      if (nextProps.status === 'success' ||
          nextProps.status === 'failed') {
        this.fireStatusResetTimer();
      }
    }
  }

  fireStatusResetTimer() {
    setTimeout(() => {
      if (this.props.onStatusReset) {
        this.props.onStatusReset();
      }
    }, 3000);
  }

  handleClick() {
    if (this.state.status === 'ready') {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }
  }

  render() {
    const {
      icon,
      label,
      successLabel,
      failedLabel,
      loadingLabel,
      disabled,
    } = this.props;
    const status = this.state.status;
    let bsStyle = 'aisz-primary';
    let content = <span>{icon} {' '} {label}</span>;
    if (status === 'success' && successLabel) {
      bsStyle = 'aisz-success';
      content = (
        <span className="animated fadeIn">
          <i className="fa fa-check-circle" />
          {' '}
          { successLabel }
        </span>
      );
    } else if (status === 'failed' && failedLabel) {
      bsStyle = 'aisz-danger';
      content = (
        <span className="animated fadeIn">
          <i className="fa fa-exclamation-triangle" />
          {' '}
          { failedLabel }
        </span>
      );
    } else if (status === 'loading' && loadingLabel) {
      content = (
        <span className="animated fadeIn">
          <i className="fa fa-spinner fa-spin" />
          {' '}
          { loadingLabel }
        </span>
      );
    }

    return (
      <Button
        className={this.props.className}
        bsStyle={bsStyle}
        onClick={this.handleClick}
        disabled={status === 'loading' || disabled}
        type={this.props.type}
      >
        {content}
      </Button>
    );
  }
}

ActionButton.defaultProps = defaultProps;
ActionButton.propTypes = propTypes;

export default ActionButton;





// WEBPACK FOOTER //
// ./src/components/ActionButton/index.jsx